import { StoreAttribute } from "@/data/types/Store";
import { StoreDetails } from "@/data/types/Store";

type ArgTypes = string | number;

export const getStoreStockAvailabilityText = (storeStockMsgs:{[key:string]:{[key:string]:(args?: ArgTypes[] | undefined) => string;}}) : {[key:string]:string}=>  ({
    "InStock" : storeStockMsgs.INVMESSAGE_InStock.t(),
    "OutOfStock" : storeStockMsgs.INVMESSAGE_OutOfStock.t(),
    "LowStock" : storeStockMsgs.INVMESSAGE_LowStock.t(),
    "CallStoreStock" : storeStockMsgs.INVMESSAGE_CallStoreStock.t(),
    "SufficientStock" : storeStockMsgs.INVMESSAGE_InStock.t(),
    "StockstockPickup" : storeStockMsgs.INVMESSAGE_StockstockPickup.t(),
})

export const StockAvailabilityColor:{[key:string]:string} = {
    "InStock" : '#368632',
    "OutOfStock" : '#E4032F',
    "LowStock" : '#802081',
    "CallStoreStock" : 'orange',
    "SufficientStock" : '#368632',
    "StockstockPickup" : '#009AD8',
}

export const StockAvailabilityColorCC:{[key:string]:string} = {
    "InStock" : '#368632',
    "OutOfStock" : '#E4032F',
    "LowStock" : '#368632',
    "CallStoreStock" : 'E4032F',
    "SufficientStock" : '#368632',
    "StockstockPickup" : '#368632',
}


export const getStoreURL = (store:StoreDetails, storeLocatorRoute:string) => {
    const city:string = findStoreAttributeValueByName(store.attributes,"seotokencity");
    const street:string = findStoreAttributeValueByName(store.attributes,"seotokenstreet");
    return city && street ? storeLocatorRoute+`/${city}`+`/${street}` : storeLocatorRoute;
}

export const findStoreAttributeValueByName = (attrs : StoreAttribute[] | undefined, name: string, returnField?:string) => {
	const attr: StoreAttribute | undefined =  attrs?.find(attr => attr.name === name);
	if(attr){
        switch (returnField) {
            case "value":
                return attr.value;
            case "displayValue":
                return attr.displayValue
            default:
                return attr.value;
        }
    }else return "";
}

export const findStoreAttributeValueByDisplayName = (attrs : StoreAttribute[] | undefined, displayName: string, returnField?:string) => {
    const attr: StoreAttribute | undefined =  attrs?.find(attr => attr?.displayName?.toLowerCase() === displayName);
	const today = new Date(); 
    const formatter = new Intl.DateTimeFormat('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric' });
    const formattedDate = formatter.format(today);
    if(attr){ 
        switch (returnField) {
            case "value":
                return attr.value;
            case "displayValue":
                if(attr.displayValue.toLowerCase() === 'gesloten') {
                    const specialTimes = findStoreAttributeByNameStartsWith(attrs,'specialopen');
                    const specialHoursToday = specialTimes?.find((spDate)=>spDate.displayName?.includes(formattedDate)); 
                    return specialHoursToday?.displayValue?.toString() ?? '';
                }
                return attr.displayValue
            default:
                return attr.value;
        }
    }else return "";
}

export const findStoreAttributeByName = (attrs : StoreAttribute[] | undefined, name: string) => {
    const attr: StoreAttribute | undefined =  attrs?.find(attr => attr.name === name);
    return attr;
}

export const findStoreAttributeByNameStartsWith = (attrs : StoreAttribute[] | undefined, name: string) => {
    return attrs?.filter(attr => attr.name.startsWith(name) ); 
}

export const getCityURL = (store:StoreDetails, storeLocatorRoute:string) => {
    const city:string = findStoreAttributeValueByName(store.attributes,"seotokencity");
    return city ? storeLocatorRoute+`/${city}`: storeLocatorRoute;
}